// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `. /* File: NMCStep.css */
.nmc-step {
  padding: 1.5rem;
  background: #f9fafc;
}

.tab-strip {
  display: flex;
  gap: 0.4rem;
  margin-bottom: 1rem;
}

.tab-btn {
  background: #e0eafc;
  border: none;
  padding: 0.5rem 1rem;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
}

.tab-btn.active {
  background: #003e8a;
  color: #fff;
}

.upload-row {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

.btn-primary {
  background-color: #003e8a;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
}

.btn-secondary {
  background-color: #ccc;
  color: black;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
}

.step-nav {
  margin-top: 2rem;
  display: flex;
  justify-content: space-between;
}

/* Modal styles */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-box {
  background: #fff;
  padding: 1.5rem;
  width: 600px;
  max-width: 90%;
  border-radius: 6px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.modal-actions {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.nmc-step h2 {
  font-size: 1.5rem;
  margin-bottom: 1.2rem;
  border-bottom: 2px solid #0072ce;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 0.3rem;
}

.required {
  color: red;
}

.flag-icon {
  width: 20px;
  height: 14px;
  object-fit: contain;
  margin-right: 0.5rem;
}

.dropdown-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.vessel-details {
  background: #f9f9f9;
  border-left: 4px solid #0072ce;
  padding: 1rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;
}

.error {
  color: red;
  font-size: 0.85rem;
}

.step-nav {
  margin-top: 1rem;
}
.cert-table table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}

.cert-table th,
.cert-table td {
  padding: 0.75rem;
  border: 1px solid #ccc;
  text-align: left;
}

.cert-table th {
  background-color: #f2f2f2;
}

.cert-table button {
  background: #d9534f;
  color: white;
  padding: 0.3rem 0.6rem;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}
.tab-switcher {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
}

.tab-switcher button {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  padding: 0.6rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
}

.tab-switcher button.active {
  background-color: #0072ce;
  color: white;
  border-color: #0072ce;
}

.metadata-preview {
  background: #eef6ff;
  border-left: 4px solid #0072ce;
  padding: 0.75rem 1rem;
  margin: 1rem 0;
  font-size: 0.9rem;
  border-radius: 5px;
}
.tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 1rem;
}

.tabs button {
  background: #004990;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px 4px 0 0;
  cursor: pointer;
}

.tabs button.active {
  background: #0061cc;
  font-weight: bold;
}

.tab-content {
  background: #fff;
  border: 1px solid #ccc;
  padding: 1rem;
  border-radius: 0 4px 4px 4px;
}

.manual-btn {
  margin-top: 0.5rem;
  background-color: #003974;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.upload-info {
  font-size: 0.9rem;
  color: #333;
  margin-top: 4px;
}

.modal {
  display: none;
  position: fixed;
  z-index: 10;
  padding-top: 80px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border-radius: 6px;
  width: 90%;
  max-width: 700px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}

.modal .close {
  float: right;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
}
.tab-buttons {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.tab-buttons button.active {
  background-color: #0072ce;
  color: white;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  width: 400px;
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
}
.tab-buttons {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.tab-buttons button {
  padding: 0.5rem 1rem;
  border: 1px solid #0072ce;
  background-color: #fff;
  color: #0072ce;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
}

.tab-buttons button.active {
  background-color: #0072ce;
  color: white;
}

.fill-btn {
  background-color: #003b7a;
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  margin-top: 0.5rem;
  cursor: pointer;
  border-radius: 4px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.modal {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 400px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.modal input {
  width: 100%;
  margin-bottom: 1rem;
  padding: 0.5rem;
}

.modal-buttons {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}
.subsection {
  margin-bottom: 2rem;
}

.file-name {
  font-size: 0.9rem;
  color: #2a7ae2;
  margin-top: 0.3rem;
}

.row-3 {
  display: flex;
  flex-wrap: wrap;
  gap: 1.2rem;
}

.row-3 .form-group {
  flex: 1 1;
  min-width: 250px;
}
.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1rem;
  margin: 1rem 0;
}

.checkbox-grid label {
  font-size: 1rem;
  background: #f5f7fa;
  padding: 0.75rem 1rem;
  border: 1px solid #d3dbe3;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: background 0.2s ease;
}

.checkbox-grid label:hover {
  background-color: #eef4fb;
}

.form-group textarea {
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #ccc;
}
.upload-preview {
  font-size: 0.9rem;
  color: #333;
  margin-top: 0.4rem;
}
.file-review-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}

.file-review-table th,
.file-review-table td {
  padding: 0.75rem;
  border: 1px solid #ccc;
  text-align: left;
  font-size: 0.95rem;
}

.file-review-table th {
  background-color: #f0f4f7;
}
/* Compliance Layout */
.with-sidebar {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.compliance-main {
  flex: 3 1;
  min-width: 60%;
}

.compliance-sidebar {
  flex: 1 1;
  background: #f9f9f9;
  padding: 1rem;
  border-left: 3px solid #0072ce;
  border-radius: 6px;
  min-width: 260px;
}
.file-review-table {
  width: 100%;
  border-collapse: collapse;
}

.file-review-table th,
.file-review-table td {
  padding: 0.6rem;
  border: 1px solid #ccc;
}

.file-review-table th {
  background: #f0f0f0;
  text-align: left;
}
.review-block {
  background: #f9f9f9;
  border-left: 4px solid #0072ce;
  margin-bottom: 1rem;
  padding: 1rem;
  border-radius: 6px;
  position: relative;
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.6rem;
}

.edit-btn {
  background: #0072ce;
  color: white;
  border: none;
  padding: 0.4rem 0.8rem;
  font-size: 0.9rem;
  border-radius: 4px;
  cursor: pointer;
}

.review-json {
  background: #fff;
  border: 1px solid #ccc;
  padding: 0.8rem;
  font-size: 0.85rem;
  overflow-x: auto;
  border-radius: 4px;
  max-height: 250px;
}

.review-actions {
  margin-top: 1.5rem;
  text-align: center;
}

.download-btn {
  background: #00bfa5;
  color: white;
  font-weight: bold;
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.download-btn:hover {
  background: #009e88;
}
.compliance-summary {
  background: #e6f5ff;
  border-left: 4px solid #0072ce;
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 6px;
  font-size: 0.95rem;
}

.declaration-section {
  background: #fff8e1;
  border-left: 4px solid #fbc02d;
  padding: 1rem;
  margin-bottom: 1.5rem;
  border-radius: 6px;
}

.submit-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
}

.submit-btn {
  background-color: #0072ce;
  color: white;
  font-weight: bold;
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn:disabled {
  background-color: #9e9e9e;
  cursor: not-allowed;
}

.reset-btn {
  background-color: #f44336;
  color: white;
  font-weight: bold;
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.compliance-bar {
  background: #e0e0e0;
  border-radius: 6px;
  height: 20px;
  position: relative;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
}

.compliance-bar .bar {
  background-color: #0072ce;
  height: 100%;
  border-radius: 6px 0 0 6px;
  transition: width 0.4s ease;
}

.score-text {
  font-size: 0.9rem;
  color: #333;
  margin-top: 0.25rem;
}

.summary-snapshot {
  background-color: #f9f9f9;
  padding: 1rem;
  border-left: 4px solid #0072ce;
  margin-bottom: 1rem;
  border-radius: 6px;
}

.success-container {
  text-align: center;
}

.success-card {
  background: #e8f5e9;
  border-left: 4px solid #2e7d32;
  padding: 1.5rem;
  margin-top: 1rem;
  border-radius: 8px;
  display: inline-block;
  text-align: left;
}

.step-controls {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 2rem;
}

.step-controls button {
  padding: 0.6rem 1.2rem;
  font-size: 1rem;
  border-radius: 5px;
  cursor: pointer;
  background-color: #0072ce;
  color: white;
  border: none;
  transition: background 0.3s ease;
}

.step-controls button:hover {
  background-color: #005fa3;
}

.step-controls .disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.compliance-progress {
  background: #f1f1f1;
  height: 10px;
  width: 100%;
  border-radius: 6px;
  margin-top: 0.75rem;
  position: relative;
  overflow: hidden;
}

.compliance-progress-bar {
  background-color: #4caf50;
  height: 100%;
  transition: width 0.4s ease-in-out;
}

.success-actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.alert-options {
  background: #f0f4f8;
  padding: 1rem;
  border-radius: 6px;
  margin-bottom: 1rem;
}
.compliance-bar {
  background: #f1f8ff;
  padding: 10px 20px;
  border-left: 4px solid #0078d7;
  margin-bottom: 20px;
  border-radius: 4px;
  font-size: 14px;
}

.compliance-bar .bar-wrapper {
  background: #e0e0e0;
  height: 10px;
  width: 100%;
  border-radius: 5px;
  margin-top: 8px;
}

.compliance-bar .bar-fill {
  background: #0078d7;
  height: 10px;
  border-radius: 5px;
  transition: width 0.5s ease-in-out;
}
/* Enhanced Styles */
.nmc-step.enhanced {
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.step-header {
  margin-bottom: 2.5rem;
  text-align: center;
}

.step-header h2 {
  font-size: 2rem;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.step-description {
  color: #7f8c8d;
  margin-bottom: 1.5rem;
}

.step-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.progress-bar {
  width: 200px;
  height: 8px;
  background: #ecf0f1;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #3498db, #2ecc71);
  transition: width 0.3s ease;
}

.form-section {
  background: #f9f9f9;
  border-radius: 10px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  border-left: 4px solid #3498db;
}

.section-title {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}

.section-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: #3498db;
  color: white;
  border-radius: 50%;
  margin-right: 1rem;
  font-weight: bold;
}

.section-title h3 {
  margin: 0;
  color: #2c3e50;
}

.form-row {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1rem;
}

.form-group {
  flex: 1 1;
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #34495e;
}

.required {
  color: #e74c3c;
  margin-right: 4px;
}

.react-select-container .react-select__control {
  border: 1px solid #ddd;
  border-radius: 6px;
  min-height: 44px;
  box-shadow: none;
  transition: all 0.3s;
}

.react-select-container .react-select__control--is-focused {
  border-color: #3498db;
  box-shadow: 0 0 0 1px #3498db;
}

.react-select-container.error-border .react-select__control {
  border-color: #e74c3c;
}

.dropdown-option {
  display: flex;
  align-items: center;
  gap: 8px;
}

.flag-icon {
  width: 20px;
  height: 15px;
  object-fit: cover;
  border-radius: 2px;
}

input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.3s;
}

input:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 1px #3498db;
}

input.error-border {
  border-color: #e74c3c;
}

.vessel-details-card {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.detail-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.detail-item {
  flex: 1 1;
  min-width: 120px;
}

.detail-label {
  display: block;
  font-size: 0.8rem;
  color: #7f8c8d;
  margin-bottom: 0.25rem;
}

.detail-value {
  font-weight: 500;
  color: #2c3e50;
}

.error-message {
  color: #e74c3c;
  font-size: 0.85rem;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
}

.next-button {
  background: linear-gradient(135deg, #3498db, #2ecc71);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s;
}

.next-button:hover {
  background: linear-gradient(135deg, #2980b9, #27ae60);
  box-shadow: 0 4px 12px rgba(52, 152, 219, 0.3);
}

.next-button i {
  transition: transform 0.3s;
}

.next-button:hover i {
  transform: translateX(3px);
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-section {
  animation: fadeIn 0.5s ease-out forwards;
}

/* Add these styles to your existing NMCStep.css */

.success-page {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  background-color: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.success-header {
  margin-bottom: 2rem;
}

.success-icon {
  margin: 0 auto 1.5rem;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e8f5e9;
  border-radius: 50%;
  border: 3px solid #4caf50;
}

.success-message {
  font-size: 1.1rem;
  color: #555;
  max-width: 600px;
  margin: 0 auto;
}

.submission-details {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin: 2rem 0;
  flex-wrap: wrap;
}

.detail-card {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 1rem;
  min-width: 220px;
}

.detail-icon {
  width: 48px;
  height: 48px;
  background-color: #e3f2fd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1976d2;
}

.detail-card h3 {
  margin: 0 0 0.5rem;
  font-size: 0.9rem;
  color: #666;
}

.detail-card p {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
}

.success-actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.action-btn span {
  display: flex;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.alert-btn {
  background-color: #ffeb3b;
  color: #333;
}

.new-submission {
  background-color: #4caf50;
  color: white;
}

.dashboard-btn {
  background-color: #2196f3;
  color: white;
}

.alert-options {
  margin-top: 2rem;
  padding: 1.5rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.alert-options h3 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: #333;
}

.department-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.department-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.8rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid #ddd;
}

.department-option:hover {
  background-color: #f5f5f5;
}

.department-option.selected {
  background-color: #e8f5e9;
  border-color: #4caf50;
}

.checkbox {
  width: 24px;
  height: 24px;
  border: 2px solid #999;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.department-option.selected .checkbox {
  background-color: #4caf50;
  border-color: #4caf50;
  color: white;
}

.department-name {
  font-weight: 500;
}

.send-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.8rem 1.5rem;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
}

.send-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.send-btn.sent {
  background-color: #8bc34a;
}
`, "",{"version":3,"sources":["webpack://./src/pages/demo/styles/NMCStep.css"],"names":[],"mappings":"AAAA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;AACA,sBAAsB;AACtB;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;AACpC;AACA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,kDAAkD;;AAElD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[". /* File: NMCStep.css */\n.nmc-step {\n  padding: 1.5rem;\n  background: #f9fafc;\n}\n\n.tab-strip {\n  display: flex;\n  gap: 0.4rem;\n  margin-bottom: 1rem;\n}\n\n.tab-btn {\n  background: #e0eafc;\n  border: none;\n  padding: 0.5rem 1rem;\n  font-weight: bold;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.tab-btn.active {\n  background: #003e8a;\n  color: #fff;\n}\n\n.upload-row {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.btn-primary {\n  background-color: #003e8a;\n  color: white;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 4px;\n}\n\n.btn-secondary {\n  background-color: #ccc;\n  color: black;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 4px;\n}\n\n.step-nav {\n  margin-top: 2rem;\n  display: flex;\n  justify-content: space-between;\n}\n\n/* Modal styles */\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-box {\n  background: #fff;\n  padding: 1.5rem;\n  width: 600px;\n  max-width: 90%;\n  border-radius: 6px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n}\n\n.modal-actions {\n  margin-top: 1rem;\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n\n.nmc-step h2 {\n  font-size: 1.5rem;\n  margin-bottom: 1.2rem;\n  border-bottom: 2px solid #0072ce;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group label {\n  font-weight: 600;\n  margin-bottom: 0.3rem;\n}\n\n.required {\n  color: red;\n}\n\n.flag-icon {\n  width: 20px;\n  height: 14px;\n  object-fit: contain;\n  margin-right: 0.5rem;\n}\n\n.dropdown-option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.vessel-details {\n  background: #f9f9f9;\n  border-left: 4px solid #0072ce;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n  border-radius: 4px;\n}\n\n.error {\n  color: red;\n  font-size: 0.85rem;\n}\n\n.step-nav {\n  margin-top: 1rem;\n}\n.cert-table table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n}\n\n.cert-table th,\n.cert-table td {\n  padding: 0.75rem;\n  border: 1px solid #ccc;\n  text-align: left;\n}\n\n.cert-table th {\n  background-color: #f2f2f2;\n}\n\n.cert-table button {\n  background: #d9534f;\n  color: white;\n  padding: 0.3rem 0.6rem;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.tab-switcher {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.tab-switcher button {\n  background-color: #f0f0f0;\n  border: 1px solid #ccc;\n  padding: 0.6rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.tab-switcher button.active {\n  background-color: #0072ce;\n  color: white;\n  border-color: #0072ce;\n}\n\n.metadata-preview {\n  background: #eef6ff;\n  border-left: 4px solid #0072ce;\n  padding: 0.75rem 1rem;\n  margin: 1rem 0;\n  font-size: 0.9rem;\n  border-radius: 5px;\n}\n.tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-bottom: 1rem;\n}\n\n.tabs button {\n  background: #004990;\n  color: white;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 4px 4px 0 0;\n  cursor: pointer;\n}\n\n.tabs button.active {\n  background: #0061cc;\n  font-weight: bold;\n}\n\n.tab-content {\n  background: #fff;\n  border: 1px solid #ccc;\n  padding: 1rem;\n  border-radius: 0 4px 4px 4px;\n}\n\n.manual-btn {\n  margin-top: 0.5rem;\n  background-color: #003974;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.upload-info {\n  font-size: 0.9rem;\n  color: #333;\n  margin-top: 4px;\n}\n\n.modal {\n  display: none;\n  position: fixed;\n  z-index: 10;\n  padding-top: 80px;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.6);\n}\n\n.modal-content {\n  background-color: #fefefe;\n  margin: auto;\n  padding: 20px;\n  border-radius: 6px;\n  width: 90%;\n  max-width: 700px;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n}\n\n.modal .close {\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n  cursor: pointer;\n}\n.tab-buttons {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.tab-buttons button.active {\n  background-color: #0072ce;\n  color: white;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 8px;\n  width: 400px;\n}\n\n.modal-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n.tab-buttons {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.tab-buttons button {\n  padding: 0.5rem 1rem;\n  border: 1px solid #0072ce;\n  background-color: #fff;\n  color: #0072ce;\n  font-weight: bold;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.tab-buttons button.active {\n  background-color: #0072ce;\n  color: white;\n}\n\n.fill-btn {\n  background-color: #003b7a;\n  color: white;\n  border: none;\n  padding: 0.6rem 1.2rem;\n  margin-top: 0.5rem;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n}\n\n.modal {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  width: 400px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n}\n\n.modal input {\n  width: 100%;\n  margin-bottom: 1rem;\n  padding: 0.5rem;\n}\n\n.modal-buttons {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n}\n.subsection {\n  margin-bottom: 2rem;\n}\n\n.file-name {\n  font-size: 0.9rem;\n  color: #2a7ae2;\n  margin-top: 0.3rem;\n}\n\n.row-3 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.2rem;\n}\n\n.row-3 .form-group {\n  flex: 1;\n  min-width: 250px;\n}\n.checkbox-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 1rem;\n  margin: 1rem 0;\n}\n\n.checkbox-grid label {\n  font-size: 1rem;\n  background: #f5f7fa;\n  padding: 0.75rem 1rem;\n  border: 1px solid #d3dbe3;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.checkbox-grid label:hover {\n  background-color: #eef4fb;\n}\n\n.form-group textarea {\n  width: 100%;\n  padding: 0.75rem;\n  font-size: 1rem;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n}\n.upload-preview {\n  font-size: 0.9rem;\n  color: #333;\n  margin-top: 0.4rem;\n}\n.file-review-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n}\n\n.file-review-table th,\n.file-review-table td {\n  padding: 0.75rem;\n  border: 1px solid #ccc;\n  text-align: left;\n  font-size: 0.95rem;\n}\n\n.file-review-table th {\n  background-color: #f0f4f7;\n}\n/* Compliance Layout */\n.with-sidebar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.compliance-main {\n  flex: 3;\n  min-width: 60%;\n}\n\n.compliance-sidebar {\n  flex: 1;\n  background: #f9f9f9;\n  padding: 1rem;\n  border-left: 3px solid #0072ce;\n  border-radius: 6px;\n  min-width: 260px;\n}\n.file-review-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.file-review-table th,\n.file-review-table td {\n  padding: 0.6rem;\n  border: 1px solid #ccc;\n}\n\n.file-review-table th {\n  background: #f0f0f0;\n  text-align: left;\n}\n.review-block {\n  background: #f9f9f9;\n  border-left: 4px solid #0072ce;\n  margin-bottom: 1rem;\n  padding: 1rem;\n  border-radius: 6px;\n  position: relative;\n}\n\n.review-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.6rem;\n}\n\n.edit-btn {\n  background: #0072ce;\n  color: white;\n  border: none;\n  padding: 0.4rem 0.8rem;\n  font-size: 0.9rem;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.review-json {\n  background: #fff;\n  border: 1px solid #ccc;\n  padding: 0.8rem;\n  font-size: 0.85rem;\n  overflow-x: auto;\n  border-radius: 4px;\n  max-height: 250px;\n}\n\n.review-actions {\n  margin-top: 1.5rem;\n  text-align: center;\n}\n\n.download-btn {\n  background: #00bfa5;\n  color: white;\n  font-weight: bold;\n  padding: 0.6rem 1.2rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.download-btn:hover {\n  background: #009e88;\n}\n.compliance-summary {\n  background: #e6f5ff;\n  border-left: 4px solid #0072ce;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border-radius: 6px;\n  font-size: 0.95rem;\n}\n\n.declaration-section {\n  background: #fff8e1;\n  border-left: 4px solid #fbc02d;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n  border-radius: 6px;\n}\n\n.submit-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-start;\n}\n\n.submit-btn {\n  background-color: #0072ce;\n  color: white;\n  font-weight: bold;\n  padding: 0.6rem 1.2rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn:disabled {\n  background-color: #9e9e9e;\n  cursor: not-allowed;\n}\n\n.reset-btn {\n  background-color: #f44336;\n  color: white;\n  font-weight: bold;\n  padding: 0.6rem 1.2rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.compliance-bar {\n  background: #e0e0e0;\n  border-radius: 6px;\n  height: 20px;\n  position: relative;\n  margin-top: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.compliance-bar .bar {\n  background-color: #0072ce;\n  height: 100%;\n  border-radius: 6px 0 0 6px;\n  transition: width 0.4s ease;\n}\n\n.score-text {\n  font-size: 0.9rem;\n  color: #333;\n  margin-top: 0.25rem;\n}\n\n.summary-snapshot {\n  background-color: #f9f9f9;\n  padding: 1rem;\n  border-left: 4px solid #0072ce;\n  margin-bottom: 1rem;\n  border-radius: 6px;\n}\n\n.success-container {\n  text-align: center;\n}\n\n.success-card {\n  background: #e8f5e9;\n  border-left: 4px solid #2e7d32;\n  padding: 1.5rem;\n  margin-top: 1rem;\n  border-radius: 8px;\n  display: inline-block;\n  text-align: left;\n}\n\n.step-controls {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.step-controls button {\n  padding: 0.6rem 1.2rem;\n  font-size: 1rem;\n  border-radius: 5px;\n  cursor: pointer;\n  background-color: #0072ce;\n  color: white;\n  border: none;\n  transition: background 0.3s ease;\n}\n\n.step-controls button:hover {\n  background-color: #005fa3;\n}\n\n.step-controls .disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n.compliance-progress {\n  background: #f1f1f1;\n  height: 10px;\n  width: 100%;\n  border-radius: 6px;\n  margin-top: 0.75rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.compliance-progress-bar {\n  background-color: #4caf50;\n  height: 100%;\n  transition: width 0.4s ease-in-out;\n}\n\n.success-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 2rem;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.alert-options {\n  background: #f0f4f8;\n  padding: 1rem;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n}\n.compliance-bar {\n  background: #f1f8ff;\n  padding: 10px 20px;\n  border-left: 4px solid #0078d7;\n  margin-bottom: 20px;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.compliance-bar .bar-wrapper {\n  background: #e0e0e0;\n  height: 10px;\n  width: 100%;\n  border-radius: 5px;\n  margin-top: 8px;\n}\n\n.compliance-bar .bar-fill {\n  background: #0078d7;\n  height: 10px;\n  border-radius: 5px;\n  transition: width 0.5s ease-in-out;\n}\n/* Enhanced Styles */\n.nmc-step.enhanced {\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 2rem;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n}\n\n.step-header {\n  margin-bottom: 2.5rem;\n  text-align: center;\n}\n\n.step-header h2 {\n  font-size: 2rem;\n  color: #2c3e50;\n  margin-bottom: 0.5rem;\n}\n\n.step-description {\n  color: #7f8c8d;\n  margin-bottom: 1.5rem;\n}\n\n.step-progress {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.progress-bar {\n  width: 200px;\n  height: 8px;\n  background: #ecf0f1;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #3498db, #2ecc71);\n  transition: width 0.3s ease;\n}\n\n.form-section {\n  background: #f9f9f9;\n  border-radius: 10px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  border-left: 4px solid #3498db;\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.section-number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  background: #3498db;\n  color: white;\n  border-radius: 50%;\n  margin-right: 1rem;\n  font-weight: bold;\n}\n\n.section-title h3 {\n  margin: 0;\n  color: #2c3e50;\n}\n\n.form-row {\n  display: flex;\n  gap: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.form-group {\n  flex: 1;\n  margin-bottom: 1rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  color: #34495e;\n}\n\n.required {\n  color: #e74c3c;\n  margin-right: 4px;\n}\n\n.react-select-container .react-select__control {\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  min-height: 44px;\n  box-shadow: none;\n  transition: all 0.3s;\n}\n\n.react-select-container .react-select__control--is-focused {\n  border-color: #3498db;\n  box-shadow: 0 0 0 1px #3498db;\n}\n\n.react-select-container.error-border .react-select__control {\n  border-color: #e74c3c;\n}\n\n.dropdown-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.flag-icon {\n  width: 20px;\n  height: 15px;\n  object-fit: cover;\n  border-radius: 2px;\n}\n\ninput {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: all 0.3s;\n}\n\ninput:focus {\n  outline: none;\n  border-color: #3498db;\n  box-shadow: 0 0 0 1px #3498db;\n}\n\ninput.error-border {\n  border-color: #e74c3c;\n}\n\n.vessel-details-card {\n  background: white;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-top: 1rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.detail-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.detail-item {\n  flex: 1;\n  min-width: 120px;\n}\n\n.detail-label {\n  display: block;\n  font-size: 0.8rem;\n  color: #7f8c8d;\n  margin-bottom: 0.25rem;\n}\n\n.detail-value {\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n.error-message {\n  color: #e74c3c;\n  font-size: 0.85rem;\n  margin-top: 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 2rem;\n}\n\n.next-button {\n  background: linear-gradient(135deg, #3498db, #2ecc71);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: all 0.3s;\n}\n\n.next-button:hover {\n  background: linear-gradient(135deg, #2980b9, #27ae60);\n  box-shadow: 0 4px 12px rgba(52, 152, 219, 0.3);\n}\n\n.next-button i {\n  transition: transform 0.3s;\n}\n\n.next-button:hover i {\n  transform: translateX(3px);\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.form-section {\n  animation: fadeIn 0.5s ease-out forwards;\n}\n\n/* Add these styles to your existing NMCStep.css */\n\n.success-page {\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 2rem;\n  background-color: #f8f9fa;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.success-header {\n  margin-bottom: 2rem;\n}\n\n.success-icon {\n  margin: 0 auto 1.5rem;\n  width: 100px;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #e8f5e9;\n  border-radius: 50%;\n  border: 3px solid #4caf50;\n}\n\n.success-message {\n  font-size: 1.1rem;\n  color: #555;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.submission-details {\n  display: flex;\n  justify-content: center;\n  gap: 1.5rem;\n  margin: 2rem 0;\n  flex-wrap: wrap;\n}\n\n.detail-card {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  min-width: 220px;\n}\n\n.detail-icon {\n  width: 48px;\n  height: 48px;\n  background-color: #e3f2fd;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #1976d2;\n}\n\n.detail-card h3 {\n  margin: 0 0 0.5rem;\n  font-size: 0.9rem;\n  color: #666;\n}\n\n.detail-card p {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.success-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.8rem 1.5rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.action-btn span {\n  display: flex;\n}\n\n.action-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.alert-btn {\n  background-color: #ffeb3b;\n  color: #333;\n}\n\n.new-submission {\n  background-color: #4caf50;\n  color: white;\n}\n\n.dashboard-btn {\n  background-color: #2196f3;\n  color: white;\n}\n\n.alert-options {\n  margin-top: 2rem;\n  padding: 1.5rem;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.alert-options h3 {\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n  color: #333;\n}\n\n.department-options {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.department-option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.8rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 1px solid #ddd;\n}\n\n.department-option:hover {\n  background-color: #f5f5f5;\n}\n\n.department-option.selected {\n  background-color: #e8f5e9;\n  border-color: #4caf50;\n}\n\n.checkbox {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #999;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.department-option.selected .checkbox {\n  background-color: #4caf50;\n  border-color: #4caf50;\n  color: white;\n}\n\n.department-name {\n  font-weight: 500;\n}\n\n.send-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.8rem 1.5rem;\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  width: 100%;\n}\n\n.send-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.send-btn.sent {\n  background-color: #8bc34a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
